import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { capitalHistoryApiConfig } from './capitalHistory/constants'
import { fetchApiData as fetchCapitalHistoryApiData } from './capitalHistory/fetchApiData'
import { getCurrentHibachiAssets } from './getCurrentAsset'
import { tradeHistoryApiConfig } from './tradeHistory/constants'
import { fetchApiData as fetchTradeHistoryApiData } from './tradeHistory/fetchApiData'

export const hibachiApiConfigs = {
  [capitalHistoryApiConfig.type]: capitalHistoryApiConfig,
  [tradeHistoryApiConfig.type]: tradeHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type HibachiApiType = keyof typeof hibachiApiConfigs

export const hibachiApiTypes = Object.keys(
  hibachiApiConfigs,
) as HibachiApiType[]

export const fetchHibachiApiDataFuncs = {
  [capitalHistoryApiConfig.type]: fetchCapitalHistoryApiData,
  [tradeHistoryApiConfig.type]: fetchTradeHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchHibachiSubTypesFuncs = {
  [capitalHistoryApiConfig.type]: undefined,
  [tradeHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentHibachiAssets }
